import * as React from "react";
import { SubHeader } from "../../components/header";
import { Spinner, UnitChange } from "../../components/molecules";
import { CurrentResultMonthlyContainer } from "../../components/planMaking/container";
import { pageConstant } from "../../constants/pageConstants";
import { useResultsOfTheCurrentTermInitialData } from "../../hooks/initialData";

export const CurrentResultMonthly = () => {
  const resultsOfTheCurrentTermCalcState =
    useResultsOfTheCurrentTermInitialData();

  const url = pageConstant.PLANS_INPUT_MONTHLY;
  const dataUrl = pageConstant.CURRENT_RESULT_MONTHLY;

  if (!resultsOfTheCurrentTermCalcState) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      <SubHeader title="今期実績（月次）" />
      <UnitChange />
      <CurrentResultMonthlyContainer
        calcState={resultsOfTheCurrentTermCalcState}
        dataUrl={dataUrl}
        url={url}
      />
    </React.Fragment>
  );
};
